import './ActivityMenu.scoped.sass'
import { MenuBottom } from '../MenuBottom/MenuBottom'
import activityService from '@/app-domains/activity/activity.service'
import sessionService from '@/app-domains/user/session/session.service'
import { getHumanReadableTime } from '@/services/timer/Timer'
import { ReactComponent as ArrowUpRightIcon } from '@/assets/icons/arrow-up-right.svg'
import { ReactComponent as ArrowDownRightIcon } from '@/assets/icons/arrow-down-right.svg'
import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon-2.svg'
import { ReactComponent as Bolt } from '@/assets/icons/bolt-lightning-solid.svg'
import store from '@/core/store'
import { useEffect, useState } from 'react'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import classNames from 'classnames'
import commonsService from '@/services/commons.service'
import activityFeedService from '@/app-domains/activity/activity.feed.service'

export function ActivityMenu () {
  const [activitiesArr, setActivitiesArr] = useState(Object.values(activityService.getStoredActivities()))
  const [activeFilter, setActiveFilter] = useState('all')
  const [isMenuShown, setIsMenuShown] = useState(true)
  const [selectedActivity, setSelectedActivity] = useState(activitiesArr[0])

  useRenderEvent(['ACTIVITIES:FILTER'], ({ filter, activities }) => {
    setActivitiesArr(activities)
    setActiveFilter(filter)
  })

  useRenderEvent(['ACTIVITIES:LOAD'], () => {
    setActivitiesArr(Object.values(activityService.getStoredActivities()))
  })

  function sendShowThreadInHistoryFeedSignal (activity) {
    if (activity?.thread) {
      setSelectedActivity(activity)
      store.commit('HISTORY_VIEW:SHOW_THREAD', activity.thread.id)
    }
    if (commonsService.isMobile()) {
      setIsMenuShown(false)
    }
  }
  function getLocalAddressesFromActivity (activity, defaultDomain) {
    return activity.rawData.boxes.map((box) => `${box.boxname}@${defaultDomain}`).join(',')
  }

  useRenderEvent(['SIDE_MENU:SHOW'], () => {
    setIsMenuShown(true)
  })

  const scrollListenerHandler = (thresholdMultiplier) => {
    activityFeedService.handleActivityFeedScroll(thresholdMultiplier)
  }

  const scrollListener = (event, thresholdMultiplier) => {
    const feedContent = document.getElementById('activity-menu-scrollable')
    feedContent.removeEventListener(event, scrollListenerHandler)
    feedContent.addEventListener(event, scrollListenerHandler.bind(this, thresholdMultiplier))
  }

  const addScrollListener = () => {
    scrollListener('scroll', 0.15)
    scrollListener('touchmove', 0.15)
  }

  useEffect(() => {
    addScrollListener()
    setTimeout(() => store.commit('HISTORY_VIEW:SHOW_THREAD', activitiesArr[0].thread.id), 80)
  }, [])

  function getMessageType (activity) {
    const style = {
      width: '10px',
      height: '10px',
    }
    if (activity.summary && activity.summary.toLowerCase().includes('message sent')) {
      return (<><ArrowUpRightIcon style={style}/>SENT</>)
    }
    if (activity.rawData?.type?.toLowerCase().includes('deletedmessage')) {
      return (<><TrashIcon style={style}/>DELETED</>)
    }
    return (<><ArrowDownRightIcon style={style}/>RECEIVED</>)
  }

  function generateActivities () {
    const defaultDomain = sessionService.getMe().me.defaultdomain
    if (!activitiesArr?.length) {
      return <div className='no-activities'>
        <div className="no-activities-content">
          <Bolt />
          No recorded activity yet.
        </div>
      </div>
    }
    return activitiesArr && activitiesArr.map((activity) => {
      if (!activity) {
        return <></>
      } else {
        return (
          <li key={activity.id} className={classNames('', { selected: activity.id === selectedActivity.id })} onClick={() => { sendShowThreadInHistoryFeedSignal(activity) }}>
            <div className="label-left activity">
              <div className='activity-header'>
                <div className='message-type'>
                  {getMessageType(activity)}
                </div>
                <div className='message-date'>
                  {getHumanReadableTime(activity.date)}
                </div>
              </div>
              <div className='activity-subject'>{activity?.rawData.message?.subject || 'No subject'}</div>
              <div className='activity-to'><b>To: </b><span className='address'>{getLocalAddressesFromActivity(activity, defaultDomain)}</span></div>
              { activity.isFrom && <div className='activity-from'><b>From: </b>{getLocalAddressesFromActivity(activity, defaultDomain)}</div>}
            </div>
          </li>
        )
      }
    })
  }
  return (
    <div className='aside-content' id='contact-menu'>
      <div className={`primary-menu ${!isMenuShown ? 'hidden-menu' : 'mb-show-menu'}`}>        <div className="primary-menu-container">      <div className="menu-top">
        <div className="menu-top-header">
          <div className="menu-top-label">
            History
          </div>
          {/* <div className="menu-top-right disabled">
            All messages <ChevronDown style={{ marginLeft: '12px' }}/>
            </div> */}
        </div>
        <div className="menu-top-filters">
          <div className={classNames('filter', { active: activeFilter === 'all' })} onClick={() => activityService.applyStoredActivitiesFilter('all')}>
            All
          </div>
          <div className={classNames('filter', { active: activeFilter === 'today' })} onClick={() => activityService.applyStoredActivitiesFilter('today')}>
            Today
          </div>
          <div className={classNames('filter', { active: activeFilter === 'this-week' })} onClick={() => activityService.applyStoredActivitiesFilter('this-week')}>
            This week
          </div>
        </div>
      </div>
        <div className="menu-content" id='activity-menu-scrollable'>
          <ul className='labels-group h-full'>
            <li className="labels-list-anchor"></li>
            {generateActivities()}
          </ul>
        </div>
        { !commonsService.isMobile() && <MenuBottom /> }
      </div>
      </div>
    </div>
  )
}
